export const WEB_LIGHT_SURFACES = {
  white: '#FFFFFF',
  paper: '#F7F4EE',
  warm: '#EBE9E4',
  lavender100: '#F0ECF4',
  olive100: '#DEE3D7',
} as const;

export const WEB_ACCESSIBLE_COLORS = {
  informativeSecondaryText: '#59605B',
  functionalBoundary: '#7A807B',
  visibleFocus: '#6F5F82',
} as const;

export const WEB_CONTRAST_POLICY = {
  normalTextMinimum: 4.5,
  functionalBoundaryMinimum: 3,
  focusWidthPx: 2,
  focusOffsetPx: 2,
  mutedTextAllowedOnlyWhenInactiveAndNonInformative: true,
  defaultBorderAllowedOnlyWhenDecorative: true,
} as const;

function relativeLuminance(hex: string): number {
  const channels = hex
    .slice(1)
    .match(/.{2}/g)
    ?.map((channel) => Number.parseInt(channel, 16) / 255)
    .map((channel) => (channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4));

  if (!channels || channels.length !== 3) {
    throw new Error('Cor hexadecimal RGB inválida');
  }

  return 0.2126 * channels[0]! + 0.7152 * channels[1]! + 0.0722 * channels[2]!;
}

export function contrastRatio(foreground: string, background: string): number {
  const first = relativeLuminance(foreground);
  const second = relativeLuminance(background);
  const lighter = Math.max(first, second);
  const darker = Math.min(first, second);
  return (lighter + 0.05) / (darker + 0.05);
}

/** Catálogo corrigido NEV-26: não reproduzir a relação histórica 8,67:1. */
export const WEB_CATALOG_CONTRAST = {
  inkOnLavender500: contrastRatio('#151A1F', '#C1B4D5'),
} as const;
